"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveDirective = void 0;
const react_1 = __importStar(require("react"));
const graphql_zeus_1 = require("graphql-zeus");
const typestyle_1 = require("typestyle");
const index_1 = require("../../../GraphQL/Convert/index");
const index_2 = require("../components/index");
const Colors_1 = require("../../../Colors");
const LastField = typestyle_1.style({
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
});
const Name = typestyle_1.style({
    fontSize: 10,
    marginRight: 4,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});
const DirectiveBackground = typestyle_1.style({
    background: Colors_1.Colors.pink[5],
});
const OptionsMenuContainer = typestyle_1.style({
    position: 'absolute',
    top: 20,
    zIndex: 2,
});
exports.ActiveDirective = ({ node, inputOpen, inputDisabled, outputOpen, outputDisabled, onInputClick, onOutputClick, last, isLocked, onDelete, }) => {
    const [detailsMenuOpen, setDetailsMenuOpen] = react_1.useState(false);
    const isEnumValue = node.data.type === graphql_zeus_1.ValueDefinition.EnumValueDefinition;
    return (react_1.default.createElement(index_2.NodeFieldContainer, { className: `${DirectiveBackground} ${last ? LastField : ''} ${inputOpen || outputOpen ? 'Active' : ''}` },
        !inputDisabled && !isLocked && !isEnumValue ? (react_1.default.createElement(index_2.FieldPort, { onClick: onInputClick, open: inputOpen, info: {
                message: 'Edit directive arguments',
                placement: 'left',
            } })) : (react_1.default.createElement("div", { className: 'NodeFieldPortPlaceholder' })),
        react_1.default.createElement(index_2.Title, null,
            react_1.default.createElement("div", { className: Name }, index_1.ConvertValueToEditableString(node))),
        !isLocked && (react_1.default.createElement(index_2.FieldPort, { icons: { closed: 'More', open: 'More' }, onClick: () => {
                setDetailsMenuOpen(!detailsMenuOpen);
            } }, detailsMenuOpen && (react_1.default.createElement("div", { className: OptionsMenuContainer },
            react_1.default.createElement(index_2.Menu, { hideMenu: () => setDetailsMenuOpen(false) },
                react_1.default.createElement(index_2.MenuScrollingArea, null,
                    react_1.default.createElement(index_2.DetailMenuItem, { onClick: onDelete }, "Delete"))))))),
        !outputDisabled && (react_1.default.createElement(index_2.FieldPort, { onClick: onOutputClick, open: outputOpen, info: {
                message: `Expand ${node.type.name} details`,
                placement: 'right',
            } })),
        outputDisabled && isLocked && react_1.default.createElement("div", { className: 'NodeFieldPortPlaceholder' })));
};
